import React from "react";

// Lightweight markdown renderer for editorial body copy (## headings, > quotes, paragraphs, **bold**, [links](url)).
export default function Markdown({ text, dark = false, accent = "" }) {
  if (!text) return null;
  const blocks = text.split(/\n\n+/);
  const renderInline = (s) => {
    const parts = s.split(/(\*\*[^*]+\*\*|\*[^*\n]+\*|\[[^\]]+\]\([^)]+\))/g);
    return parts.map((p, i) => {
      if (p.startsWith("**") && p.endsWith("**")) {
        return <strong key={i} className="font-semibold">{p.slice(2, -2)}</strong>;
      }
      if (p.length > 2 && p.startsWith("*") && p.endsWith("*")) {
        return <em key={i} className="italic">{p.slice(1, -1)}</em>;
      }
      const lm = p.match(/^\[([^\]]+)\]\(([^)]+)\)$/);
      if (lm) {
        const href = /^https?:/i.test(lm[2]) ? lm[2] : `https://${lm[2]}`;
        return <a key={i} href={href} target="_blank" rel="noreferrer" className="underline underline-offset-2 decoration-1 hover:opacity-70 transition-opacity">{lm[1]}</a>;
      }
      return <React.Fragment key={i}>{p}</React.Fragment>;
    });
  };
  return (
    <div className={`prose-glossy ${dark ? "dark" : ""}`}>
      {blocks.map((block, i) => {
        const b = block.trim();
        if (b.startsWith("# ")) return i === 0 ? null : <h2 key={i}>{renderInline(b.slice(2))}</h2>;
        if (b.startsWith("## ")) return <h2 key={i}>{renderInline(b.slice(3))}</h2>;
        if (b.startsWith("> ")) return <blockquote key={i} style={accent ? { borderColor: accent } : undefined}>{renderInline(b.slice(2))}</blockquote>;
        return <p key={i}>{renderInline(b)}</p>;
      })}
    </div>
  );
}
